import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function restartTradePlanBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Restarting trade plan.
        {parsedStatusObj.minutesInTradePlan
          ? 'Minutes in trade plan:' + parsedStatusObj.minutesInTradePlan + '.'
          : ''}{' '}
        {parsedStatusObj.numberOfTrades
          ? 'Number of trades:' + parsedStatusObj.numberOfTrades + '.'
          : ''}{' '}
        {parsedStatusObj.restartAttempts
          ? 'Restart attempts:' + parsedStatusObj.restartAttempts + '.'
          : ''}
      </Body3>
    </td>
  );
}
